var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowPrevious = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 17,
  viewBox: "0 0 10 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.46981 8.48902L10 15.7106L9.16747 16.5054L0.769226 8.48902L9.16747 0.505371L10 1.30071L2.46981 8.48902Z",
  fill: "#4585FF"
})));
export default SvgArrowPrevious;